export function getBackupLanguageValue(
  field: string,
  object: any,
  cultureCookieId: any,
  isConvertion: any,
  backupLangauageId: any,
): {} {
  if (object.isEdited && field === "text") {
    return atob(object.text);
  }
  let value: string = "";
  const cultureCookieIndex = object.recommendationMullang.findIndex(
    (x: any) => x.languageId == cultureCookieId,
  );
  const backupLangauageIndex = object.recommendationMullang.findIndex(
    (x: any) => x.languageId == backupLangauageId,
  );
  if (cultureCookieIndex !== -1) {
    value = object.recommendationMullang[cultureCookieIndex][field];
    if (isConvertion) {
      return atob(value);
    }
    return value;
  }
  if (backupLangauageIndex !== -1) {
    value = object.recommendationMullang[backupLangauageIndex][field];
    if (isConvertion) {
      return atob(value);
    }
    return value;
  }
  return value;
}
